import React, { useEffect, createContext, useContext } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
const AuthContext = createContext();

export const RequireAuthAdmin = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const authenticated = useSelector((state) => state.auth.authenticated);
  const authLoading = useSelector((state) => state.auth.loading);
  const user = useSelector((state) => state.auth.user);
  const userRole = user?.role || user?.type; // Support both 'role' and 'type' fields
  const [isRehydrated, setIsRehydrated] = React.useState(false);

  useEffect(() => {
    // Give redux-persist time to rehydrate
    const timer = setTimeout(() => {
      setIsRehydrated(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Don't check authentication until rehydrated and not loading
    if (isRehydrated && !authLoading) {
      checkAuthentication();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, authLoading, isRehydrated, userRole, location, params]);

  const checkAuthentication = () => {
    // Check if user is authenticated
    if (!authenticated) {
      navigate("/login");
      return;
    }

    // Check if user has admin role
    if (userRole !== "admin") {
      navigate("/");
      return;
    }

    // Check if URL starts with /admin (extra security check)
    if (location.pathname.startsWith("/admin") && userRole !== "admin") {
      navigate("/");
      return;
    }
  };

  // Show nothing while loading auth state or rehydrating
  if (!isRehydrated || authLoading) {
    return null;
  }

  // Only render children if authenticated AND admin
  return authenticated && userRole === "admin" ? children : null;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
